import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Tooltip from "@mui/material/Tooltip";
import AlertIcon from "@mui/icons-material/Warning";
import IconButton from "@mui/material/IconButton";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import loader from "../../Images/ajax-loader.gif";
import { ToastContainer, toast } from "react-toastify";
import {
  insertResourcesTable,
  getResourcesDetails,
  deleteResourcesDetails,
  updateResourcesTable,
  disableResourcesDetails,
  get_entity_type,
  getDistrict,
  getBlockByDistrict,
  getVillageByBlock,
} from "../../api/User";
import "../Admin/table.css"
const FacilitatorAsResourcePerson = ({ designationFacilitator, department }) => {
  const [errors, setErrors] = useState({});
  const userId = sessionStorage.getItem("user_id");
  const [blocks, setBlocks] = useState([]);
  const [villages, setVillages] = useState([]);
  const role_id = sessionStorage.getItem("role_id");
  const gpID = sessionStorage.getItem("gp_data") || "";
  const [otherDepartmentInput, setOtherDepartmentInput] = useState(false);
  const [loading, setLoading] = useState(false);
  const [entries, setEntries] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [formData, setFormData] = useState({
    user_id: userId,
    designation: "",
    mobile_no: "",
    full_name: "",
    email: "",
    entity_name: "",
    entity_type: "",
    district: "",
    block: "",
    gram_panchayat: "3",
    department_name: "",
    other_department_name: "",
  });
  const [formErrors, setFormErrors] = useState({
    designation: "",
    mobile_no: "",
    full_name: "",
    email: "",
    entity_name: "",
    entity_type: "",
    district: "",
    block: "",
    gram_panchayat: "",
    department_name: "",

  });
  const [filteredData, setFilteredData] = useState([]);
  const [token, setToken] = useState(sessionStorage.getItem("token") || "");
  const [EntityTypeErr, setEntityTypeErr] = useState("");
  const [lgdCode, setLgdCode] = useState("");
  const [rows, setRows] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [DepartmentNameErr, setDepartmentNameErr] = useState("");
  const [othersDepartmentInput, setOthersDepartmentInput] = useState(false);
  const [editData, setEditData] = useState({
    user_id: userId,
    designation: "",
    other_designation: "",
    mobile_no: "",
    full_name: "",
    email: "",
    entity_name: "",
    entity_type: "",
    district: "",
    block: "",
    gram_panchayat: "",
    department_name: "",
    otherDepartmentName: "",
  });
  const [othersInput, setOthersInput] = useState(false);
  const [entityTypes, setEntityTypes] = useState([]);
  const [editOthersInput, setEditOthersInput] = useState(false);
  const [editOtherValue, setEditOtherValue] = useState("");
  const [entity, setEntity] = useState("");
  const [districts, setDistricts] = useState([]);
  const [entityName, setEntityName] = useState([]);
  const navigate = useNavigate();
  const [showOtherDesignation, setShowOtherDesignation] = useState(false);
  const [showFormFields, setShowFormFields] = useState(false);
  const [resources, setResources] = useState([]);
  const fetchData = async () => {
    const data = {
      role_id: role_id,
      gp_data_id: "all",
    };
    try {
      const res = await getResourcesDetails(token, data);
      console.log(res);
      if (res.status === "success") {
        console.log(res.data);
        setFilteredData(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("An error occurred while fetching data.", { autoClose: 1000 });
    }
  };
  useEffect(() => {
    handleReset();
    setOthersInput(false);
    setOthersDepartmentInput(false);
    fetchData();
  }, []);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (resources && resources.length > 0) {
        const payload = {
          resources: resources.map(item => ({
            user_id: userId,
            full_name: item.full_name,
            mobile_no: item.mobile_no,
            email: item.email,
            entity_type: 3,
            designation: item.designation === 'Other' ? item.other_designation : item.designation,
            department_name: item.department_name,
            // district: item.district_name,
            // district_code: formData.district_code, 
            district: item.district_code,
            // block: item.block_name,
            block: item.block_code,
            // gram_panchayat: item.gram_panchayat,
            gram_panchayat: item.gram_panchayat_code,
          }))
        };
        await insertResourcesTable(token, payload);
        toast.success("Records Inserted Successfully", { autoClose: 1000 });
        fetchData();
        setResources([]);
        setFormData({
          user_id: userId,
          full_name: '',
          mobile_no: '',
          email: '',
          entity_type: '',
          district_name: '',
          district_code: '',
          block_name: '',
          block_code: '',
          gram_panchayat_name: '',
          gram_panchayat_code: '',
          designation: '',
          other_designation: '',
        });
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        toast.error("No entries to submit", { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Error occurred during submission");
    } finally {
      setLoading(false);
    }
  };

  const validateMobileNo = (mobile_no) => {
    if (!mobile_no) return "Mobile Number is required.";
    if (!/^\d{10}$/.test(mobile_no)) return "Mobile Number must be exactly 10 digits.";
    if (mobile_no[0] === '0') return "Mobile Number cannot start with zero.";
    if (/^0{10}$/.test(mobile_no)) return "Mobile Number cannot be all zeros.";
    return "";
  };
  const validateFullName = (fullName) => {
    if (!fullName) {
      return "Officer Name is required.";
    }
    const invalidCharRegex = /[^A-Z\s]/;
    if (invalidCharRegex.test(fullName)) {
      return "Officer Name cannot contain numbers or special characters.";
    }
    return "";
  };
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const handleDepartmentChange = (e) => {
    console.log(e.target.value);
    setFormData((prevState) => ({
      ...prevState,
      other_department_name: e.target.value,
    }));
  };
  const handleEdit = (index) => {
    const selectedRecord = filteredData[index];
    const isOtherDesignation = !designationFacilitator.includes(selectedRecord.designation);
    const isOtherDepartment = !department.includes(selectedRecord.department_name);
    setEditData({
      ...selectedRecord,
      designation: isOtherDesignation ? "Other" : selectedRecord.designation,
      customDesignation: isOtherDesignation ? selectedRecord.designation : "",
      department_name: isOtherDepartment ? "Other" : selectedRecord.department_name,
      otherDepartmentName: isOtherDepartment ? selectedRecord.department_name : "",
      entity_type: selectedRecord.entity_type,
    });
    fetchBlocks(selectedRecord.district_code);
    setVillages([]);
    fetchVillages(selectedRecord.district_code, selectedRecord.block_code);
    setOthersInput(isOtherDesignation);
    setOthersDepartmentInput(isOtherDepartment);
    setOpenEditModal(true);
  };
  const handleEditChange = (event) => {
    const { name, value } = event.target;
    setEditData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value.trim() ? "" : prevErrors[name],
    }));
    if (name === "entity_type") {
      let updatedEntityName = '';
      if (value === "Gram Panchayat") {
        updatedEntityName = entityName.village;
      } else if (value === "Block Panchayat") {
        updatedEntityName = entityName.block;
      } else if (value === "District Panchayat") {
        updatedEntityName = entityName.district;
      }
      setEditData((prevState) => {
        let updatedEntityType = value;
        let updatedEntityName = prevState.entity_type;
        if (name === "entity_type" && value == 3) {
          updatedEntityType = "Gram Panchayat";
        }
        return {
          ...prevState,
          [name]: value,
          entity_type: updatedEntityType,
          entity_name: updatedEntityName,
          district: value === "District Panchayat" ? "" : prevState.district,
          block: ["Block Panchayat", "Gram Panchayat"].includes(value) ? "" : prevState.block,
          gram_panchayat: value === "Gram Panchayat" ? "" : prevState.gram_panchayat,
        };
      });
      setDistricts([]);
      setBlocks([]);
      setVillages([]);
      fetchDistricts();
    }
    // else if (name === "district") {
    //   setEditData((prevState) => ({
    //     ...prevState,
    //     district: value, // Assuming value is the district code
    //     block: "",
    //     gram_panchayat: "",
    //     district_code: value, // Store the district code
    //   }));
    //   fetchBlocks(value);
    //   setBlocks([]);
    //   setVillages([]);
    // }
    else if (name === "block_code") {
      const district_code = editData.district_code;
      setEditData((prevState) => ({
        ...prevState,
        block: value,
        gram_panchayat: "",
      }));
      setVillages([]);
      fetchVillages(district_code, value);
    } else if (name === "mobile_no") {
      const numericValue = value.replace(/\D/g, '').slice(0, 10);
      setEditData((prevState) => ({
        ...prevState,
        [name]: numericValue,
      }));
      setErrors((prevState) => ({
        ...prevState,
        [name]: validateMobileNo(numericValue),
      }));
    } else if (name === "full_name") {
      const uppercaseValue = value.toUpperCase();
      const cleanedValue = uppercaseValue.replace(/[^A-Z\s]/g, '');
      setEditData((prevState) => ({
        ...prevState,
        [name]: cleanedValue,
      }));
      setErrors((prevState) => ({
        ...prevState,
        [name]: cleanedValue.trim() ? "" : "Officer Name is required.",
      }));
    } else if (name === 'designation') {
      const isOther = value === "Other";
      setEditData((prevState) => ({
        ...prevState,
        [name]: value,
        customDesignation: isOther ? prevState.customDesignation || "" : "",
      }));
      setOthersInput(isOther);
    } else if (name === 'otherDesignation') {
      setEditData((prevState) => ({
        ...prevState,
        customDesignation: value,
      }));
    }
    else if (name === 'department_name') {
      const isOther = value === "Other";
      setEditData((prevState) => ({
        ...prevState,
        [name]: value,
        otherDepartmentName: isOther ? prevState.otherDepartmentName || "" : "",
      }));
      setOthersDepartmentInput(isOther);
    } else if (name === 'otherDepartmentName') {
      setEditData((prevState) => ({
        ...prevState,
        otherDepartmentName: value,
      }));
    }
    if (name === "entity_type") {

      setFormData({
        ...formData,
        entity_type: value,
        district: "",
        block: "",
        gram_panchayat: "",
      });
      setDistricts([]);
      setBlocks([]);
      setVillages([]);

      fetchDistricts();
    } else if (name === "district") {
      setEditData((prevState) => ({
        ...prevState,
        district: value,
        block: "",
        gram_panchayat: "",
        district_code: value,
      }));
      fetchBlocks(value);
      setBlocks([]);
      setVillages([]);
    } else if (name === "block") {
      setFormData({
        ...formData,
        block: value,
        gram_panchayat: "",
      });
      setVillages([]);
      const district_code = formData.district;
      fetchVillages(district_code, value);
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
    if (name === "block") {
      const district_code = formData.district;
      fetchVillages(district_code, value);
    }
    if (name === "district_code") {
      fetchBlocks(value);
    }
    else if (name === "district_code") {
      fetchDistricts(value);
      setEditData((prevState) => ({
        ...prevState,
        [name]: value,
      }));

    }
    else if (name === "block") {
      setEditData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
    else if (name === "gram_panchayat") {
      setEditData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };
  const handleEditSubmit = async (event) => {
    event.preventDefault();
    const errors = {
      full_name: editData.full_name.trim() ? "" : "Officer Name is required.",
      mobile_no: validateMobileNo(editData.mobile_no),
      email: editData.email ? "" : "Email ID is required.",
      entity_type: editData.entity_type ? "" : "Entity Type is required.",
      designation: editData.designation ? "" : "Designation is required.",
      district: editData.designdistrictation ? "" : "District is required.",
      block: editData.block ? "" : "Block is required.",
      gram_panchayat: editData.gram_panchayat ? "" : "Gram Panchayat is required.",
    };
    setErrors(errors);
    const hasErrors = Object.values(errors).some((error) => error !== "");
    try {
      const dataToSubmit = {
        ...editData,
        designation: editData.customDesignation || editData.designation,
        department_name: editData.otherDepartmentName || editData.department_name
      };
      const res = await updateResourcesTable(token, dataToSubmit);
      if (res.status === "success") {
        toast.success(res.message, { autoClose: 1000 });
        fetchData();
        handleReset();
        setOpenEditModal(false);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error updating record:", error);
      toast.error("An error occurred while updating the record.", { autoClose: 1000 });
    }
    setOthersInput(false);
    setOthersDepartmentInput(false);
  };
  const handleReset = () => {
    setFormData({
      user_id: userId,
      designation: "",
      mobile_no: "",
      full_name: "",
      email: "",
      entity_type: "",
      other_designation: "",
      district: "",
      block: "",
      gram_panchayat: "",
      department_name: "",
    });
    setOtherDepartmentInput(false);
    setFormErrors({
      designation: "",
      mobile_no: "",
      full_name: "",
      email: "",
      entity_type: "",
      district: "",
      block: "",
      gram_panchayat: "",
      department_name: "",
    });
    setEntity("")
    setOthersInput(false);
    setOthersDepartmentInput(false);
  };
  const handleDelete = (index) => {
    setDeleteIndex(index);
    setOpenDialog(true);
  };
  const handleConfirmDelete = async () => {
    if (deleteIndex !== null) {
      try {
        const idToDelete = filteredData[deleteIndex].id;
        await deleteResourcesDetails(token, idToDelete);
        const updatedData = filteredData.filter((_, i) => i !== deleteIndex);
        setFilteredData(updatedData);
        toast.success("Deleted successfully", { autoClose: 1000 });
      } catch (error) {
        console.error("Error deleting item:", error);
        toast.error("An error occurred while deleting the item.", { autoClose: 1000 });
      }
    }
    setOpenDialog(false);
  };
  const handleCancelDelete = () => {
    setOpenDialog(false);
  };
  const handleToggleActive = (index) => {
    const updatedData = filteredData.map((row, i) =>
      i === index ? { ...row, active: !row.active } : row
    );
    setFilteredData(updatedData);
  };
  const handleDisableButton = async (is_active, ID) => {
    const newIsActive = is_active === 1 ? 0 : is_active;
    const data = {
      id: ID,
    };
    try {
      const res = await disableResourcesDetails(token, data);
      if (res.status === "success") {
        setRows((prevRows) =>
          prevRows.map((row) =>
            row.id === ID ? { ...row, is_active: newIsActive } : row
          )
        );
        toast.success("Updated successfully", { autoClose: 1000 });
        fetchData();
      } else {
        toast.error("An error occurred while updating the item.", { autoClose: 1000 });
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.", { autoClose: 1000 });
    }
  };
  const handleDesignationChange = (e) => {
    console.log(e.target.value);
    formData.designation = e.target.value
  };
  const handleEditDesignationChange = (e) => {
    const newValue = e.target.value;
    console.log(newValue);
    setEditData((prevState) => ({
      ...prevState,
      designation: newValue,
    }));
    setEditOtherValue(newValue);
  };
  useEffect(() => {
    const fetchEntityTypes = async () => {
      try {
        const res = await get_entity_type(token);
        if (res.status === "success") {
          setEntityTypes(res.data);
        } else {
          toast.error(res.message, { autoClose: 1000 });
        }
      } catch (error) {
        console.error("Error fetching entity types:", error);
        toast.error("An error occurred while fetching entity types.", { autoClose: 1000 });
      }
    };
    fetchEntityTypes();
  }, [token]);
  const fetchDistricts = async () => {
    try {
      const res = await getDistrict(token);
      if (res.status === "success") {
        setDistricts(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching districts:", error);
      toast.error("An error occurred while fetching districts.", { autoClose: 1000 });
    }
  };
  useEffect(() => {
    fetchDistricts();
  }, []);
  const fetchBlocks = async (district_code) => {
    try {
      const res = await getBlockByDistrict(token, district_code);
      if (res.status === "success") {
        setBlocks(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching blocks:", error);
      toast.error("An error occurred while fetching blocks.", { autoClose: 1000 });
    }
  };
  const fetchVillages = async (district_code, block_code) => {
    try {
      const res = await getVillageByBlock(token, district_code, block_code);
      if (res.status === "success") {
        setVillages(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching villages:", error);
      toast.error("An error occurred while fetching villages.", { autoClose: 1000 });
    }
  };
  const handleInputChange = (name) => (event) => {
    setFormData({
      ...formData,
      [name]: event.target.value,
    });
  };
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));

    if (name === "mobile_no") {
      const numericValue = value.replace(/\D/g, '').slice(0, 10);
      setFormData((prevState) => ({
        ...prevState,
        [name]: numericValue,
      }));
      setFormErrors((prevState) => ({
        ...prevState,
        [name]: numericValue.length === 10 ? "" : "Mobile number must be exactly 10 digits",
      }));
    }
    else if (name === "full_name") {
      const uppercaseValue = value.toUpperCase();
      const cleanedValue = uppercaseValue.replace(/[^A-Z\s]/g, '');
      setFormData((prevState) => ({
        ...prevState,
        [name]: cleanedValue,
      }));
      setFormErrors((prevState) => ({
        ...prevState,
        [name]: cleanedValue.trim() ? "" : 'Officer Name is required',
      }));
    }
    else if (name === "other_designation") {
      const cleanedValue = value.trim();
      const firstChar = cleanedValue.charAt(0);
      const isValid = cleanedValue.length > 0 && /^[A-Za-z]/.test(firstChar);

      setFormData((prevState) => ({
        ...prevState,
        [name]: cleanedValue,
      }));

      setFormErrors((prevState) => ({
        ...prevState,
        [name]: isValid ? "" : 'Other Designation is required',
      }));
    }

    else if (name === "email") {
      const lowercaseValue = value.toLowerCase();
      setFormData((prevState) => ({
        ...prevState,
        [name]: lowercaseValue,
      }));
      setFormErrors((prevState) => ({
        ...prevState,
        [name]: validateEmail(lowercaseValue) ? "" : "Invalid email format",
      }));
    }
    if (name === "designation") {
      setOthersInput(value === "Other");
    }
    if (name === "district") {
      const updatedData = districts.filter((item) => item.district_code == value);
      setBlocks([]);
      setVillages([]);
      fetchBlocks(value);
      setFormData((prevState) => ({
        ...prevState,
        district: value,
        district_name: updatedData[0].district,
        district_code: value,
      }));
      setFormErrors((prevState) => ({
        ...prevState,
        district: "",
      }));
    }
    if (name === "block") {
      const selectedBlock = blocks.find((block) => block.block_code == value);
      setVillages([]);
      const distcode = formData.district;
      fetchVillages(distcode, value);
      setFormData((prevState) => ({
        ...prevState,
        block_name: selectedBlock?.block,
        block_code: value,
      }));
      setFormErrors((prevState) => ({
        ...prevState,
        block: "",
      }));
    }
    if (name === "gram_panchayat") {
      const selectedVillage = villages.find(
        (village) => village.gram_panchayat_code == value
      );
      setFormData((prevState) => ({
        ...prevState,
        gram_panchayat: value,
        gram_panchayat_name: selectedVillage?.gram_panchayat || "",
        gram_panchayat_code: value,
      }));
      setFormErrors((prevState) => ({
        ...prevState,
        gram_panchayat: "",
      }));
    }
    if (name === "entity_type") {
      let updatedEntityName = "";
      if (value === "Block Panchayat") {
        updatedEntityName = entityName.block;
      } else if (value === "District Panchayat") {
        updatedEntityName = entityName.district;
      }
      setFormData((prevState) => ({
        ...prevState,
        entity_type: value,
        entity_name: updatedEntityName,
        gram_panchayat: value === "Block Panchayat" || value === "District Panchayat" ? "" : prevState.gram_panchayat,
        district_name: value === "District Panchayat" ? "" : prevState.district_name,
        block_name: ["Intermediate Panchayat", "Gram Panchayat"].includes(value) ? "" : prevState.block_name,
      }));
      setEntity(updatedEntityName);
    }
  };

  const handleAddResource = (e) => {
    setShowTable(true);
    e.preventDefault();
    const errors = {};
    const trimmedFullName = formData.full_name.trim();

    if (!trimmedFullName) {
      errors.full_name = 'Officer Name is required';
    }
    if (!formData.mobile_no) {
      errors.mobile_no = 'Mobile No is required';
    } else {
      if (!/^\d{10}$/.test(formData.mobile_no)) {
        errors.mobile_no = 'Mobile No must be 10 digits';
      } else if (/^0{10}$/.test(formData.mobile_no)) {
        errors.mobile_no = 'Mobile No cannot be all zeroes';
      } else if (formData.mobile_no.startsWith('0')) {
        errors.mobile_no = 'Mobile No cannot start with 0';
      }
    }
    if (!formData.email) {
      errors.email = 'Email ID is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = 'Invalid Email ID format';
    }
    if (!formData.designation) {
      errors.designation = 'Designation is required';
    }
    if (formData.designation === 'Other' && !formData.other_designation) {
      errors.other_designation = 'Other Designation is required';
    }
    if (!formData.district) {
      errors.district = 'District Name is required';
    }
    if (!formData.block) {
      errors.block = 'Block Name is required';
    }
    if (!formData.gram_panchayat) {
      errors.gram_panchayat = 'Gram Panchayat Name is required';
    }

    setFormErrors(errors);
    if (Object.keys(errors).length > 0) return;

    const newResource = {
      full_name: formData.full_name,
      mobile_no: formData.mobile_no,
      email: formData.email,
      designation: formData.designation === 'Other' ? formData.other_designation : formData.designation,
      department_name: department?.[0],
      district_name: formData.district_name,
      district_code: formData.district_code,
      block_name: formData.block_name,
      block_code: formData.block_code,
      gram_panchayat: formData.gram_panchayat_name,
      gram_panchayat_code: formData.gram_panchayat_code,
      entity_type: "Gram Panchayat",
    };

    setResources((prevResources) => [...prevResources, newResource]);
    toast.success("Records added successfully!", { autoClose: 1000 });

    setFormData({
      full_name: '',
      mobile_no: '',
      email: '',
      designation: '',
      other_designation: '',
      department_name: '',
      district: '',
      district_code: '',
      block: '',
      block_code: '',
      gram_panchayat: '',
      gram_panchayat_code: '',
    });
  };

  const handleDeleteResource = (index) => {
    const updatedResources = resources.filter((_, i) => i !== index);
    setResources(updatedResources);
  };
  const handleResetAllRows = () => {
    setResources([]);
  };

  return ( 
  <>
    <div id="loading-coupon" style={{ display: loading ? "flex" : "none" }}>
      <img id="loading-image" src={loader} alt="Loading..." />
    </div>
    <div className="container-fluid" style={{
      height: "95vh",
      backgroundColor: "ffffff",
      padding: "20px",
      marginTop: "-17px",
    }}>
      <div className="ms-2" style={{ height: "90vh" }}>
        <div
          style={{
            backgroundColor: '#fffff',
            padding: '16px',
            marginTop: "-32px",
            marginLeft: '-32px',
            marginRight: '-32px',
            paddingLeft: '48px',
            paddingRight: '48px',
          }}
        >
          <h2
            className="pt-10"
            style={{
              top: "0",
              left: "0",
              margin: "16px",
              fontWeight: "bold",
            }}
          >
            Facilitator As Resource Person
            </h2>
        </div>


        <div style={{
          backgroundColor: "white",
          borderRadius: "12px",
          padding: "20px",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
          margin: "16px"
        }}>
        <form className="row g-3 p-3">
          <div className="col-md-4">
            <label htmlFor="department_name" className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
              Department Name <span style={{ color: "red" }}>*</span>
            </label>
            <select
              className={`form-select ${formErrors.department_name ? "is-invalid" : ""}`}
              name="department_name"
              id="editDepartmentName"
              value={department?.[0]}
              disabled
              required
            >
              {department?.map((item, index) => (
                <option key={index} value={item}>
                  {item}
                </option>
              ))}
            </select>
            {formErrors.department_name && (
              <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                {formErrors.department_name}
              </p>
            )}
          </div>
          {otherDepartmentInput && (
            <div className="col-md-4">
              <label
                htmlFor="other_department_name"
                className="form-label"
                style={{ fontSize: "0.9rem", fontWeight: "800" }}
              >
                Other Department Name <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                className={`form-control ${formErrors.other_department_name ? "is-invalid" : ""}`}
                name="other_department_name"
                placeholder="Enter Other Department Name"
                id="other_department_name"
                value={formData.other_department_name || ""}
                onChange={handleInputChange("other_department_name")}
              />
              {formErrors.other_department_name && (
                <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                  {formErrors.other_department_name}
                </p>
              )}
            </div>
          )}
          <div className="col-md-4">
            <label htmlFor="full_name" className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
              Officer Name <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              className={`form-control ${formErrors.full_name ? "is-invalid" : ""}`}
              name="full_name"
              id="full_name"
              value={formData.full_name}
              onChange={handleChange}
              placeholder="Enter the Officer Name"
              required
            />
            {formErrors.full_name && (
              <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                {formErrors.full_name}
              </p>
            )}
          </div>
          <div className="col-md-4">
            <label htmlFor="designation" className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
              Designation <span style={{ color: "red" }}>*</span>
            </label>
            <select
              className={`form-select ${formErrors.designation ? "is-invalid" : ""}`}
              name="designation"
              id="editDesignation"
              value={formData.designation}
              onChange={handleChange}
              required
            >
              <option value="" disabled>Select Designation</option>
              {designationFacilitator?.map((item, index) => (
                <option key={index} value={item}>{item}</option>
              ))}
            </select>
            {formErrors.designation && (
              <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                {formErrors.designation}
              </p>
            )}
          </div>
          {othersInput && (
            <div className="col-md-4">
              <label
                htmlFor="other_designation"
                className="form-label"
                style={{ fontSize: "0.9rem", fontWeight: "bold" }}
              >
                Other Designation <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                className={`form-control ${formErrors.other_designation ? "is-invalid" : ""}`}
                name="other_designation"
                value={formData.other_designation || ""}
                placeholder="Enter Other Designation"
                onChange={handleChange}
              />
              {formErrors.other_designation && (
                <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                  {formErrors.other_designation}
                </p>
              )}
            </div>
          )}
          <div className="col-md-4">
            <label htmlFor="mobile_no" className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
              Mobile No <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              className={`form-control ${formErrors.mobile_no ? "is-invalid" : ""}`}
              name="mobile_no"
              id="mobile_no"
              value={formData.mobile_no}
              onChange={handleChange}
              placeholder="Enter the Mobile No"
              required
            />
            {formErrors.mobile_no && (
              <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                {formErrors.mobile_no}
              </p>
            )}
          </div>
          <div className="col-md-4">
            <label htmlFor="email" className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
              Email ID <span style={{ color: "red", fontWeight: "800" }}>*</span>
            </label>
            <input
              type="email"
              className={`form-control ${formErrors.email ? "is-invalid" : ""}`}
              name="email"
              id="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter the Email ID"
              required
            />
            {formErrors.email && (
              <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                {formErrors.email}
              </p>
            )}
          </div>
          <div className="col-md-4">
            <label htmlFor="entity_type" className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
              Entity Type <span style={{ color: "red" }}>*</span>
            </label>
            <select
              className={`form-control ${formErrors.entity_type ? "is-invalid" : ""}`}
              name="entity_type"
              id="entity_type1"
              value={formData.entity_type || "3"}
              onChange={handleChange}
              disabled
            >
              <option value="" disabled>
                Select Entity Type
              </option>
              {entityTypes.map((item, index) => (
                <option key={index} value={item.entity_code}>
                  {item.entity_name}
                </option>
              ))}
            </select>
            {formErrors.entity_type && (
              <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                {formErrors.entity_type}
              </p>
            )}
          </div>
          <div className="col-md-4">
            <label htmlFor="district" className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
              District Name <span style={{ color: "red" }}>*</span>
            </label>
            <select
              className={`form-select ${formErrors.district ? "is-invalid" : ""}`}
              name="district"
              id="district"
              value={formData.district || ""}
              onChange={handleChange}
            >
              <option value="" disabled>
                Select District Name
              </option>
              {districts?.map((district, index) => (
                <option key={index} value={district.district_code}>
                  {district.district}
                </option>
              ))}
            </select>
            {formErrors.district && (
              <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                {formErrors.district}
              </p>
            )}
          </div>
          <div className="col-md-4">
            <label htmlFor="block" className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
              Block Name <span style={{ color: "red" }}>*</span>
            </label>
            <select
              className={`form-select ${formErrors.block ? "is-invalid" : ""}`}
              name="block"
              id="block"
              value={formData.block || ""}
              onChange={handleChange}
            >
              <option value="" disabled>
                Select Block Name
              </option>
              {blocks?.map((block, index) => (
                <option key={index} value={block.block_code}>
                  {block.block}
                </option>
              ))}
            </select>
            {formErrors.block && (
              <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                {formErrors.block}
              </p>
            )}
          </div>
          <div className="col-md-4">
            <label htmlFor="gram_panchayat" className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
              Gram Panchayat Name <span style={{ color: "red" }}>*</span>
            </label>
            <select
              className={`form-select ${formErrors.gram_panchayat ? "is-invalid" : ""}`}
              name="gram_panchayat"
              id="gram_panchayat"
              value={formData.gram_panchayat || ""}
              onChange={handleChange}
            >
              <option value="" disabled>
                Select Gram Panchayat Name
              </option>
              {villages?.map((village, index) => (
                <option key={index} value={village.gram_panchayat_code}>
                  {village.gram_panchayat}
                </option>
              ))}
            </select>
            {formErrors.gram_panchayat && (
              <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                {formErrors.gram_panchayat}
              </p>
            )}
          </div>

          <div className="d-flex justify-content-end">
            <div className="col-md-2 row mt-2">
              <Button
                variant="contained"
                onClick={handleAddResource} sx={{
                  width: "70%",
                  backgroundColor: "#4763E430",
                  color: "#4763E4",
                  "&:hover": {
                     backgroundColor: "#4763E4",
                        color: "#fff"
                  },
                }}
              >
                Add
              </Button>
            </div>
          </div>
          {resources.length > 0 && showTable && (
            <>
              <div className="p-0" style={{ overflowX: 'auto', maxHeight: '33vh', marginTop: '20px' }}>
              <Table aria-label="simple table"
                      style={{ marginBottom: "20px" }} >                 
                         <TableHead
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 1,
                      backgroundColor: "rgb(232 233 246)",
                    }}
                  >
                    <TableRow>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        SR NO.
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        DEPARTMENT NAME
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        OFFICER NAME
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        DESIGNATION
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        MOBILE NUMBER
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        EMAIL ID
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        ENTITY TYPE
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        DISTRICT
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        BLOCK
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        GRAM PANCHAYAT
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        ACTION
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {resources.map((item, index) => (
                      <TableRow key={item.id}
                            style={{
                              backgroundColor: index % 2 === 0 ? "#ffffff" : " #3235760A"
                            }}>
                        <TableCell align="center">{index + 1}</TableCell>
                        <TableCell align="center">{item.department_name}</TableCell>
                        <TableCell align="center">{item.full_name}</TableCell>
                        <TableCell align="center">{item.customDesignation || item.designation}</TableCell>
                        <TableCell align="center">{item.mobile_no}</TableCell>
                        <TableCell align="center">{item.email}</TableCell>
                        <TableCell align="center">{item.entity_type}</TableCell>
                        <TableCell align="center">{item.district_name}</TableCell>
                        <TableCell align="center">{item.block_name}</TableCell>
                        <TableCell align="center">{item.gram_panchayat}</TableCell>
                        <TableCell align="center" style={{ width: '100px' }}>
                              <Tooltip title="Delete" arrow>
                                <IconButton
                                  onClick={() => handleDeleteResource(index)}
                                  sx={{
                                    color: '#e53935', // Red icon color for delete
                                    backgroundColor: 'transparent', // No background color
                                    '&:hover': {
                                      backgroundColor: 'transparent', // No background change on hover
                                      boxShadow: '0 4px 10px black', // Subtle shadow effect on hover
                                    },
                                    transition: 'box-shadow 0.3s', // Smooth transition for shadow only
                                    boxShadow: 'none', // No default shadow
                                    padding: '0px', // No extra padding for clean look
                                  }}
                                >
                                  <DeleteIcon sx={{ fontSize: '24px' }} />
                                </IconButton>
                              </Tooltip>
                            </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
              <div className="d-flex justify-content-end">
                <div className="col-md-2 row mt-2">
                  <Button
                    variant="contained"
                    onClick={handleResetAllRows}
                    sx={{
                      width: "70%",
                      backgroundColor: "#4763E430",
                      color: "#4763E4",
                      "&:hover": {
                        backgroundColor: "#4763E4",
                        color: "#fff"
                      },
                    }}
                  >
                    Cancel
                  </Button>
                </div>
                <div className="col-md-2 row mt-2">
                  <Button
                    variant="contained"
                    onClick={handleSubmit}
                    sx={{
                      width: "70%",
                      backgroundColor: "#4763E430",
                      color: "#4763E4",
                      "&:hover": {
                        backgroundColor: "#4763E4",
                        color: "#fff"
                      },
                    }}
                  >
                    Submit
                  </Button>

                </div>
              </div>
            </>
          )}
        </form>
        <ToastContainer />
      </div>
      </div>
      </div>
    </>
  );
};
export default FacilitatorAsResourcePerson;